import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HTMLRenderer from 'react-html-renderer';

function ContentsView({ data }) {
  return (
    <StyledContentContainer id="content">
      <div className="c-contents">
        <HTMLRenderer
          html={data?.content}
          // components={{
          //   h1: props => <Heading color="red" {...props} />,
          //   h2: Subheading,
          //   a: Link,
          // }}
        />
      </div>
    </StyledContentContainer>
  );
}

const StyledContentContainer = styled.section``;

ContentsView.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
};

ContentsView.defaultProps = {
  data: {},
};

export default ContentsView;
